import { render, staticRenderFns } from "./RegisterModalSiChuan.vue?vue&type=template&id=11e227eb&scoped=true&"
import script from "./RegisterModalSiChuan.vue?vue&type=script&lang=js&"
export * from "./RegisterModalSiChuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e227eb",
  null
  
)

export default component.exports